import { render } from "./AdditionalCosts.vue?vue&type=template&id=4eb7acaf&scoped=true&ts=true"
import script from "./AdditionalCosts.vue?vue&type=script&lang=ts"
export * from "./AdditionalCosts.vue?vue&type=script&lang=ts"

import "./AdditionalCosts.vue?vue&type=style&index=0&id=4eb7acaf&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb7acaf"]])

export default __exports__